const U = (id, w = 1200) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMG = {
  heroKitchen: U('photo-1556912173-3bb406ef7e77', 2000),
  livingRoom: '/work/living-room.jpg',
  dining: '/work/dining-room.jpg',
  kitchen: '/work/kitchen.jpg',
  bathroom: '/work/bathroom-after.jpg',
  bedroom: '/work/bedroom-1.jpg',
  hallway: U('photo-1600607687939-ce8a6c25118c'),
  homeOffice: U('photo-1593062096033-9a26b09da705'),
  staircase: '/work/staircase.jpg',
  basement: U('photo-1765959617888-30837a158667'),
  ceiling: U('photo-1582203423341-64b918240e25'),
  trimDoors: '/work/door-after.jpg',
  deck: '/work/deck-stained.jpg',
  siding: '/work/siding.jpg',
  garage: '/work/garage-doors-2.jpg',
  painter: '/work/prep-protection.jpg',
  interiorLux: U('photo-1704040686413-2c607dbd2f06'),
  exteriorHouse: '/work/exterior-after.jpg',
  deckDetail: '/work/deck-progress.jpg',
  brunel: '/work/team-brunel.jpg',
  jay: '/work/team-jay.jpg',
  cyrille: '/work/team-cyrille.jpg',
};

export const BADGES = {
  bbb: '/badges/bbb.png',
  google: '/badges/google.webp',
  canadian: '/badges/canadian.png',
};

export const GOOGLE_PROFILE_URL = 'https://share.google/WBE8L7zn1h1G1HE6Q';

export const PHONE = '613-859-5893';
export const PHONE_HREF = 'tel:+16138595893';
export const EMAIL = 'experts@reverence.services';

export const SERVICES = [
  {
    slug: 'interior-painting',
    name: 'Interior Painting',
    tagline: 'Walls, ceilings and whole rooms repainted with razor-sharp lines and zero mess left behind.',
    img: '/work/bedroom-1.jpg',
    metaTitle: 'Interior Painting in Ottawa | Reverence Services',
    metaDesc: 'Ottawa interior painters for walls, ceilings and full-home repaints. Fixed written quotes, spotless job sites, WSIB-covered crews. Free quote in 60 seconds.',
    included: ['Walls and ceilings in any room', 'Two premium coats, full coverage', 'Drywall patching and sanding', 'Furniture moved and protected', 'Complete cleanup, daily'],
    process: [
      { t: 'Walkthrough & fixed quote', d: 'We measure, note every repair, and hand you a written price that never changes.' },
      { t: 'Prep & protect', d: 'Floors sheeted, furniture wrapped, edges taped, holes filled and sanded smooth.' },
      { t: 'Paint & inspect', d: 'Two coats of premium paint, cut lines checked in raking light before we call it done.' },
      { t: 'Walkthrough together', d: 'You inspect every room with the crew lead before we pack up a single drop sheet.' },
    ],
    faqs: [
      { q: 'How much does it cost to paint a room in Ottawa?', a: 'Most standard bedrooms run $350–$600 with two coats and prep included. Larger or high-ceiling rooms are quoted on site — always as a fixed written price.' },
      { q: 'Do you move furniture?', a: 'Yes. We move, wrap and centre furniture, then put everything back. You never lift anything.' },
      { q: 'Can you paint while we live in the house?', a: 'Yes. We sequence rooms so you always have usable space, and we clean up fully at the end of every day.' },
    ],
  },
  {
    slug: 'exterior-painting',
    name: 'Exterior Painting',
    tagline: 'Siding, brick, stucco and soffits repainted to survive Ottawa winters and look sharp doing it.',
    img: IMG.exteriorHouse,
    metaTitle: 'Exterior Painting in Ottawa | Reverence Services',
    metaDesc: 'Exterior house painters in Ottawa for siding, brick and stucco. Proper prep, premium coatings, fixed quotes. Book a free estimate.',
    included: ['Siding, brick, stucco and soffits', 'Pressure wash and full scrape', 'Spot-priming on bare surfaces', 'Doors, shutters and garage doors', 'Full site cleanup'],
    process: [
      { t: 'Assessment & fixed quote', d: 'We inspect every elevation, flag failing coatings and quote one fixed price.' },
      { t: 'Wash & scrape', d: 'Pressure wash, scrape to a sound edge, sand and spot-prime bare areas.' },
      { t: 'Coat & detail', d: 'Premium exterior coatings applied to manufacturer spec, trim detailed by hand.' },
      { t: 'Final inspection', d: 'A full lap around the house with you before we call it finished.' },
    ],
    faqs: [
      { q: 'When is exterior painting season in Ottawa?', a: 'Typically May through October, when overnight lows stay above 10°C. Summer bookings fill fast — reserve early.' },
      { q: 'How long does an exterior repaint last?', a: 'With proper prep and premium coatings, 8–12 years on siding. Prep is 70% of longevity, and we never skip it.' },
      { q: 'Can you paint brick or vinyl siding?', a: 'Yes. We use coatings rated for masonry and vinyl-safe colours that will not warp panels.' },
    ],
  },
  {
    slug: 'trim-and-doors',
    name: 'Trim, Doors & Staircases',
    tagline: 'Baseboards, casings, doors, railings and staircases finished with the crisp detail that makes a whole home feel expensive.',
    img: IMG.staircase,
    metaTitle: 'Trim, Door & Staircase Painting in Ottawa | Reverence Services',
    metaDesc: 'Ottawa painters for baseboards, doors, railings and staircases. Glass-smooth enamel finishes and razor-sharp cut lines. Free quote.',
    included: ['Baseboards, casings and crown', 'Interior and exterior doors', 'Stair railings, spindles and risers', 'Durable enamel finishes', 'Caulking and gap filling included'],
    process: [
      { t: 'Fixed quote', d: 'Counted by the opening and linear foot — one written price.' },
      { t: 'Fill & sand', d: 'Nail holes filled, old runs sanded, gaps caulked for seamless lines.' },
      { t: 'Enamel finish', d: 'Self-levelling trim enamels applied for a glass-smooth result.' },
      { t: 'Detail check', d: 'Every cut line inspected before we leave.' },
    ],
    faqs: [
      { q: 'Can you paint stair railings and spindles?', a: 'Yes — railings, spindles, stringers and risers. It is detailed work and one of our specialties.' },
      { q: 'Which finish is best for trim?', a: 'A quality waterborne enamel in satin or semi-gloss: durable, washable and non-yellowing.' },
      { q: 'Do you remove doors to paint them?', a: 'Where it improves the finish, yes — doors can be sprayed flat off-site and rehung.' },
    ],
  },
  {
    slug: 'deck-and-fence-staining',
    name: 'Deck & Fence Staining',
    tagline: 'Decks and fences washed, sanded and stained to handle freeze-thaw, UV and everything an Ottawa backyard throws at them.',
    img: IMG.deck,
    metaTitle: 'Deck & Fence Staining in Ottawa | Reverence Services',
    metaDesc: 'Deck and fence staining in Ottawa. Wash, sand, premium stain, fixed quotes. Protect your wood before winter — free estimate.',
    included: ['Decks, fences, railings and pergolas', 'Wash, strip and brighten prep', 'Sanding of traffic surfaces', 'Premium penetrating stains', 'Solid, semi-transparent or clear finishes'],
    process: [
      { t: 'Moisture check & quote', d: 'We test the wood, check for rot, and quote a fixed price.' },
      { t: 'Wash & sand', d: 'Deep clean, strip failing stain, sand traffic surfaces smooth.' },
      { t: 'Stain & seal', d: 'Penetrating stain applied to saturation, back-brushed for even colour.' },
      { t: 'Cure guidance', d: 'Clear instructions on furniture and foot-traffic timing.' },
    ],
    faqs: [
      { q: 'How often should a deck be restained in Ottawa?', a: 'Every 2–3 years for semi-transparent finishes; solid stains last 4–5. Freeze-thaw is hard on wood here.' },
      { q: 'Can you stain a deck that was painted?', a: 'Paint must be stripped before stain can penetrate. We assess on site and quote honestly.' },
      { q: 'When is the best time to stain?', a: 'Late May through September, with 24–48 dry hours after application. We watch the forecast so you do not have to.' },
    ],
  },
];

export const TILES = [
  { label: 'Living Rooms', slug: 'living-rooms', type: 'interior', img: IMG.livingRoom },
  { label: 'Dining Rooms', slug: 'dining-rooms', type: 'interior', img: IMG.dining },
  { label: 'Kitchens', slug: 'kitchens', type: 'interior', img: IMG.kitchen },
  { label: 'Bathrooms', slug: 'bathrooms', type: 'interior', img: IMG.bathroom },
  { label: 'Bedrooms', slug: 'bedrooms', type: 'interior', img: IMG.bedroom },
  { label: 'Halls & Foyers', slug: 'halls-foyers', type: 'interior', img: IMG.hallway },
  { label: 'Home Offices', slug: 'home-offices', type: 'interior', img: IMG.homeOffice },
  { label: 'Staircases', slug: 'staircases', type: 'interior', img: IMG.staircase },
  { label: 'Basements', slug: 'basements', type: 'interior', img: IMG.basement },
  { label: 'Ceilings', slug: 'ceilings', type: 'interior', img: IMG.ceiling },
  { label: 'Trim & Doors', slug: 'trim-doors', type: 'interior', img: IMG.trimDoors },
  { label: 'Decks & Fences', slug: 'decks-fences', type: 'exterior', img: IMG.deck },
  { label: 'Siding', slug: 'siding', type: 'exterior', img: IMG.siding },
  { label: 'Garages', slug: 'garages', type: 'exterior', img: IMG.garage },
];

export const GALLERY_EXTRA = [
  { label: 'Full Home Exterior', slug: 'exteriors', type: 'exterior', img: IMG.exteriorHouse },
  { label: 'Exterior In Progress', slug: 'siding', type: 'exterior', img: '/work/exterior-progress.jpg' },
  { label: 'Before & After: Brick to Navy', slug: 'siding', type: 'exterior', img: '/work/ba-brick-navy.jpg' },
  { label: 'Before & After: Green to Grey', slug: 'siding', type: 'exterior', img: '/work/ba-green-grey.jpg' },
  { label: 'Before & After: Deck Staining', slug: 'decks-fences', type: 'exterior', img: '/work/ba-deck.jpg' },
  { label: 'Deck, Fresh Cedar Brown', slug: 'decks-fences', type: 'exterior', img: '/work/deck-stained.jpg' },
  { label: 'Deck Sanding Day', slug: 'decks-fences', type: 'exterior', img: '/work/deck-sanded.jpg' },
  { label: 'Deck Before: Weathered Cedar', slug: 'decks-fences', type: 'exterior', img: '/work/deck-weathered.jpg' },
  { label: 'Railing Detail at Golden Hour', slug: 'decks-fences', type: 'exterior', img: '/work/deck-railing.jpg' },
  { label: 'Deck Staining In Progress', slug: 'decks-fences', type: 'exterior', img: '/work/deck-progress.jpg' },
  { label: 'Fresh Deck, Clear Finish', slug: 'decks-fences', type: 'exterior', img: '/work/deck-after.jpg' },
  { label: 'Front Doors, Classic Red', slug: 'trim-doors', type: 'exterior', img: '/work/door-after.jpg' },
  { label: 'Front Doors In Progress', slug: 'trim-doors', type: 'exterior', img: '/work/door-progress.jpg' },
  { label: 'Garage Doors, Deep Navy', slug: 'garages', type: 'exterior', img: '/work/garage-doors-2.jpg' },
  { label: 'Garage Doors In Progress', slug: 'garages', type: 'exterior', img: '/work/garage-doors-1.jpg' },
  { label: 'Siding & Deck Refresh', slug: 'siding', type: 'exterior', img: '/work/siding.jpg' },
  { label: 'Kitchen, Fresh Grey Walls', slug: 'kitchens', type: 'interior', img: '/work/kitchen.jpg' },
  { label: 'Dining Room, Fresh White', slug: 'dining-rooms', type: 'interior', img: '/work/dining-room.jpg' },
  { label: 'Bedroom Repaint', slug: 'bedrooms', type: 'interior', img: '/work/bedroom-2.jpg' },
  { label: 'Guest Bedroom in Soft Grey', slug: 'bedrooms', type: 'interior', img: '/work/grey-bedroom.jpg' },
  { label: 'Primary Bedroom Repaint', slug: 'bedrooms', type: 'interior', img: '/work/bedroom-3.jpg' },
  { label: 'Bedroom in Warm Neutral', slug: 'bedrooms', type: 'interior', img: '/work/bedroom-4.jpg' },
  { label: 'Guest Bedroom Repaint', slug: 'bedrooms', type: 'interior', img: '/work/bedroom-5.jpg' },
  { label: 'Bedroom in Warm Cream', slug: 'bedrooms', type: 'interior', img: '/work/bedroom-cream.jpg' },
  { label: 'Bedroom & Ceiling Refresh', slug: 'bedrooms', type: 'interior', img: '/work/bedroom-fan.jpg' },
  { label: 'Closet & Built-ins, Fresh White', slug: 'bedrooms', type: 'interior', img: '/work/closet-builtins.jpg' },
  { label: 'Sunroom in Soft White', slug: 'living-rooms', type: 'interior', img: '/work/sunroom.jpg' },
  { label: 'Sunroom In Progress', slug: 'living-rooms', type: 'interior', img: '/work/sunroom-2.jpg' },
  { label: 'Wall Patch & Prep', slug: 'living-rooms', type: 'interior', img: '/work/cyrille-wall-patch.jpg' },
  { label: 'Bright Entryway Refresh', slug: 'halls-foyers', type: 'interior', img: '/work/entryway.jpg' },
  { label: 'Bathroom In Progress', slug: 'bathrooms', type: 'interior', img: '/work/bathroom-progress.jpg' },
  { label: 'Bathroom Before: Tired Walls', slug: 'bathrooms', type: 'interior', img: '/work/bathroom-before.jpg' },
  { label: 'Bathroom Before: Outdated Oak', slug: 'bathrooms', type: 'interior', img: '/work/bathroom-prep.jpg' },
  { label: 'Bathroom Prep, Drop Sheets Down', slug: 'bathrooms', type: 'interior', img: '/work/bathroom-dropsheets.jpg' },
  { label: 'Bathroom Prep Day', slug: 'bathrooms', type: 'interior', img: '/work/cyrille-bathroom.jpg' },
  { label: 'Cutting In, Trim Work', slug: 'trim-doors', type: 'interior', img: '/work/jay-cutting-in.jpg' },
  { label: 'On Site With Cyrille', slug: 'bathrooms', type: 'interior', img: '/work/cyrille-bathroom.jpg', video: '/work/cyrille-working.mp4' },
  { label: 'Main Floor Repaint', slug: 'living-rooms', type: 'interior', img: IMG.interiorLux },
];

export const BEFORE_AFTER = [
  { img: '/work/ba-brick-navy.jpg', label: 'Brick to navy — full exterior' },
  { img: '/work/ba-deck.jpg', label: 'Deck sanding & staining' },
  { img: '/work/ba-green-grey.jpg', label: 'Green to grey — full exterior' },
];

export const PROMISES = [
  { icon: 'Clock', title: 'On-time crews', line: 'We show up when we said we would — every day, on schedule.' },
  { icon: 'PenLine', title: 'Fixed written quotes', line: 'The price we write is the price you pay. No surprises, ever.' },
  { icon: 'Sparkles', title: 'Spotless job sites', line: 'Drop sheets, taped edges, and no mess left behind. Guaranteed.' },
  { icon: 'ShieldCheck', title: 'Workmanship guarantee', line: 'Every job backed by a 2-year workmanship warranty, in writing.' },
];

export const STEPS = [
  { n: '01', t: 'Free estimate', d: 'Tell us about your project in 60 seconds. We visit, measure and hand you a fixed written quote.' },
  { n: '02', t: 'We schedule your crew', d: 'Pick your dates. Your crew arrives on time, protects everything, and gets to work.' },
  { n: '03', t: 'Painted right, guaranteed', d: 'Walkthrough together at the end. Perfect lines, spotless site, 2-year warranty in writing.' },
];

export const TEAM = [
  { name: 'Brunel', role: 'Owner & Lead Estimator', specialty: 'Whole-home repaints & colour consults', years: 15, img: IMG.brunel, pos: '50% 25%' },
  { name: 'Jay', role: 'Interior Specialist', specialty: 'Interior trim & cutting-in', years: 11, img: IMG.jay },
  { name: 'Cyrille', role: 'Exterior Lead', specialty: 'Exteriors & siding', years: 12, img: IMG.cyrille },
];

export const COMPARISON = [
  { label: 'Fixed written quotes', us: 'One price, in writing', them: 'Estimates that grow' },
  { label: 'Insured, WSIB-covered crews', us: '$2M liability + WSIB', them: 'Often uninsured' },
  { label: 'Premium paint & proper prep', us: 'Benjamin Moore & Sherwin-Williams', them: 'Whatever is cheapest' },
  { label: 'Cleanup included', us: 'Spotless, every day', them: 'You find the mess' },
  { label: 'Workmanship warranty', us: '2 years, in writing', them: 'Good luck' },
];

export const REVIEWS = [
  { name: 'Marie-Claire D.', area: 'Orléans', service: 'Interior Painting', text: 'Brunel quoted on Tuesday, the crew started Monday, and the whole main floor was done in three days. The cut lines are perfect and they left the house cleaner than they found it.', rating: 5 },
  { name: 'Jason P.', area: 'Barrhaven', service: 'Exterior Painting', text: 'Our siding was chalking and peeling. Cyrille\'s crew washed, scraped and repainted the whole exterior in under a week. Neighbours keep knocking to ask who did it.', rating: 5 },
  { name: 'Priya S.', area: 'Kanata', service: 'Interior Painting', text: 'They repainted our whole main floor — walls, ceilings and trim — in four days flat. Zero mess, great colour advice, and the fixed quote never moved.', rating: 5 },
  { name: 'Tom & Linda H.', area: 'Manotick', service: 'Trim, Doors & Staircases', text: 'Jay painted every door, baseboard and the oak staircase. The enamel finish is glass-smooth. Punctual, quiet, and genuinely careful people.', rating: 5 },
  { name: 'Greg W.', area: 'Nepean', service: 'Exterior Painting', text: 'They washed, scraped and repainted our entire brick exterior in under a week. Fixed quote, WSIB paperwork provided upfront, and a professional crew from start to finish.', rating: 5 },
  { name: 'Aisha K.', area: 'Stittsville', service: 'Deck Staining', text: 'Deck was grey and tired. They washed, sanded and stained it in two days and it looks better than the day it was built. Already booked them for the fence.', rating: 5 },
];

export const TICKER = [
  'Exterior repaint completed in Barrhaven',
  'Main floor repaint wrapped in Orléans',
  'Full interior repaint wrapped in Westboro',
  'Deck staining finished in Stittsville',
  'Stairwell repaint finished in Orléans',
  'Bedroom refresh done in Kanata',
  'Staircase enamelled in The Glebe',
];

export const HOME_FAQS = [
  { q: 'How much does it cost to paint a room in Ottawa?', a: 'Most standard bedrooms cost $350–$600 with prep and two coats included. Whole-home interiors typically run $2,500–$7,000 depending on size and condition. Every quote is fixed and in writing before work starts.' },
  { q: 'How long does a painting job take?', a: 'A single room takes one day. A full main floor usually takes 2–4 days, and a full exterior 4–7 days depending on weather and prep. You get a schedule with your quote.' },
  { q: 'What paint brands do you use?', a: 'We paint with Benjamin Moore and Sherwin-Williams as standard, with Dulux available on request. Premium paint covers better and lasts years longer.' },
  { q: 'Do you handle prep and priming?', a: 'Yes — filling, sanding, caulking and priming are included in every quote. Prep is roughly 70% of a lasting paint job, and we never skip it.' },
  { q: 'Do you move furniture?', a: 'Yes. We move, wrap and protect furniture, then put everything back. Floors are sheeted and edges taped before a can is opened.' },
  { q: 'How long is your warranty?', a: 'Every job carries a 2-year workmanship warranty, in writing. If our work peels, chips or fails, we come back and fix it free.' },
  { q: 'How far ahead should I book?', a: 'Interior work usually books 1–2 weeks out. Summer exteriors fill 3–4 weeks ahead, so early booking is smart. We always keep room for urgent jobs.' },
  { q: 'Can you paint interiors in winter?', a: 'Absolutely. Winter is interior season in Ottawa — modern low-VOC paints cure fine indoors, and scheduling is fastest from November to March.' },
  { q: 'Is the quote really free?', a: 'Yes. The visit, the written quote and the colour advice are all free, with zero obligation to book. Most quotes are in your inbox within 24 hours.' },
];

export const AREAS = [
  { slug: 'orleans', name: 'Orléans', copy: 'Our home base. From Fallingbrook to Avalon, we have painted hundreds of Orléans homes — interiors, exteriors, trim and everything in between.' },
  { slug: 'ottawa', name: 'Ottawa Core', copy: 'From Westboro semis to Glebe heritage homes and Centretown condos, our crews work across central Ottawa every week.' },
  { slug: 'barrhaven', name: 'Barrhaven', copy: 'Barrhaven\'s growing neighbourhoods are some of our busiest. Full interiors and exterior repaints are our most-booked jobs here.' },
  { slug: 'kanata', name: 'Kanata', copy: 'From Kanata Lakes to Bridlewood, we handle whole-home interiors and exterior repaints built to survive the west end\'s freeze-thaw cycles.' },
  { slug: 'nepean', name: 'Nepean', copy: 'Mature Nepean homes often need careful prep — plaster repair, stained trim, brick exteriors. It is exactly the work we do best.' },
  { slug: 'stittsville', name: 'Stittsville', copy: 'Stittsville decks and fences take a beating. Our staining crews protect them, and our interior teams handle the rest of the house while they are at it.' },
  { slug: 'gatineau', name: 'Gatineau', copy: 'We cross the river for residential projects across Gatineau, with fully insured, WSIB-covered crews.' },
];

export const PARTNERS = ['Benjamin Moore', 'Sherwin-Williams', 'Dulux', 'PPG Paints', 'Home Hardware', 'BBB Accredited'];

export const BLOG_POSTS = [
  {
    slug: 'how-much-does-it-cost-to-paint-a-room-in-ottawa',
    title: 'How Much Does It Cost to Paint a Room in Ottawa?',
    excerpt: 'Real 2026 Ottawa pricing for bedrooms, main floors and whole homes — plus the three things that move a quote up or down.',
    date: 'June 2026',
    category: 'Pricing',
    img: IMG.livingRoom,
    body: [
      { type: 'p', text: 'The honest answer: a standard Ottawa bedroom costs $350–$600 to paint professionally, including prep, two coats of premium paint and cleanup. A full main floor typically lands between $1,500 and $3,000, and a whole-home interior between $2,500 and $7,000.' },
      { type: 'h', text: 'What moves the price' },
      { type: 'p', text: 'Three things drive a painting quote. Condition: walls with cracks, stains or old wallpaper need more prep hours. Height: cathedral ceilings and stairwells need staging and take longer. And scope: ceilings, trim and doors are priced separately from walls.' },
      { type: 'h', text: 'Why fixed quotes matter' },
      { type: 'p', text: 'An estimate that grows mid-job is not an estimate — it is a guess. Insist on a written, fixed price after an in-person visit. Every Reverence quote works this way: we measure, we note every repair, and the number we write is the number you pay.' },
      { type: 'h', text: 'The cheapest quote is rarely the cheapest job' },
      { type: 'p', text: 'Prep is 70% of a lasting paint job. A quote that skips filling, sanding and priming saves a few hundred dollars now and costs a full repaint in three years. Ask every bidder to list their prep steps in writing.' },
    ],
  },
  {
    slug: 'best-time-to-paint-your-home-exterior-in-ottawa',
    title: 'The Best Time to Paint Your Home Exterior in Ottawa',
    excerpt: 'Ottawa\'s exterior season is shorter than you think. Here is the real window, why temperature matters, and when to book.',
    date: 'May 2026',
    category: 'Exteriors',
    img: IMG.exteriorHouse,
    body: [
      { type: 'p', text: 'Ottawa\'s exterior painting season runs roughly May through October. The rule that matters is overnight temperature: modern exterior coatings need nights above 10°C to cure properly, which is why late May to late September is the sweet spot.' },
      { type: 'h', text: 'Why temperature and moisture matter' },
      { type: 'p', text: 'Paint that cures too cold never fully hardens, and paint applied to damp siding traps moisture that blisters the coating by spring. We moisture-test siding before we quote and watch the forecast so your job lands in a proper weather window.' },
      { type: 'h', text: 'The booking reality' },
      { type: 'p', text: 'Good exterior crews in Ottawa book 3–4 weeks out by June. If you want your house painted this summer, the time to get a quote is now — not when the siding starts peeling in August.' },
      { type: 'h', text: 'How long it should last' },
      { type: 'p', text: 'With full prep — wash, scrape, sand, spot-prime — and a premium topcoat, an Ottawa exterior repaint should last 8–12 years. Anything less almost always traces back to skipped prep.' },
    ],
  },
];

export const SERVICE_FAQ_LD = (service) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: service.faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});

export const faqLd = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});
